/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumTipoDomandaDTOCaricamentoPdfRiepilogoModalitaFirma =
  (typeof EnumTipoDomandaDTOCaricamentoPdfRiepilogoModalitaFirma)[keyof typeof EnumTipoDomandaDTOCaricamentoPdfRiepilogoModalitaFirma];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumTipoDomandaDTOCaricamentoPdfRiepilogoModalitaFirma = {
  DIGITALE: 'DIGITALE',
  DIGITALE_O_AUTOGRAFA: 'DIGITALE_O_AUTOGRAFA',
  SOLO_PADES: 'SOLO_PADES',
  SOLO_CADES: 'SOLO_CADES',
} as const;
